'use strict';

module.exports = {
    leaflet: 'leaflet',
    tv: 'tv',
    radio: 'radio',
};
